(function () {
  function init(root) {
    var track = root.querySelector("[data-sunnier-reviews-track]");
    var prev = root.querySelector("[data-sunnier-reviews-prev]");
    var next = root.querySelector("[data-sunnier-reviews-next]");
    if (!track || !prev || !next) return;

    function cardStep() {
      var card = track.querySelector(".sunnier-reviews-scroller__card");
      if (!card) return 280;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || "14") || 14;
      return Math.max(200, card.getBoundingClientRect().width + gap);
    }

    function setDisabled(btn, disabled) {
      btn.classList.toggle("is-disabled", disabled);
      btn.setAttribute("aria-disabled", disabled ? "true" : "false");
      btn.tabIndex = disabled ? -1 : 0;
    }

    function updateButtons() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth - 4);
      setDisabled(prev, track.scrollLeft <= 4);
      setDisabled(next, track.scrollLeft >= max);
    }

    prev.addEventListener("click", function () {
      if (prev.getAttribute("aria-disabled") === "true") return;
      track.scrollBy({ left: -cardStep(), behavior: "smooth" });
    });

    next.addEventListener("click", function () {
      if (next.getAttribute("aria-disabled") === "true") return;
      track.scrollBy({ left: cardStep(), behavior: "smooth" });
    });

    track.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);
    requestAnimationFrame(updateButtons);
    setTimeout(updateButtons, 200);
  }

  function boot() {
    document.querySelectorAll("[data-sunnier-reviews-scroller]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    var root = event.target.querySelector("[data-sunnier-reviews-scroller]");
    if (root) init(root);
  });
})();
